import { z } from 'zod'

import { ESlots, broadbandPremiseSchema } from '@giffgaff/broadband-common'

import { OrderStateDetail } from '@/constants'

import { broadbandPlanMemberSchema } from './plans.schemas'

export const orderStateTypes = z.nativeEnum(OrderStateDetail)

const appointmentNotesSchema = z.object({
  engineerInstructions: z.string().optional(),
  healthAndSafety: z.string().optional(),
})

export const orderDetailActiveAppointmentsSchema = z.object({
  id: z.string(),
  appointmentDate: z.string(),
  slot: z.nativeEnum(ESlots),
  earliestArrivalTime: z.string(),
  latestArrivalTime: z.string(),
  visitType: z.string(),
  estimatedDurationInMinutes: z.number(),
  inHomeLeadTimeInDays: z.number(),
  state: z.string(),
  stateDescription: z.string().optional(),
  notes: z.string().optional(),
  healthAndSafetyNotes: z.string(),
  healthAndSafety: z.string().optional(),
  outsideMemberCutoff: z.boolean().optional(),
  appointmentNotes: appointmentNotesSchema.optional(),
  contactFirstName: z.string(),
  contactLastName: z.string(),
  contactPhoneNumber: z.string(),
  contactSecondaryPhoneNumber: z.string().optional(),
  engineerName: z.string().optional(),
  engineerContactNumber: z.string().optional(),
  engineerInstructions: z.string().optional(),
  formattedArrivalTime: z.string(),
  rebookingRequired: z.boolean(),
  amendable: z.boolean(),
})
export type OrderDetailActiveAppointments = z.infer<typeof orderDetailActiveAppointmentsSchema>

export const ServiceReferralSchema = z
  .object({
    redeemedReferralCode: z.string(),
  })
  .optional()

export type ServiceReferral = z.infer<typeof ServiceReferralSchema>

export const memberReferralSchema = z
  .object({
    referralCode: z.string(),
    memberId: z.string(),
  })
  .optional()

export type MemberReferral = z.infer<typeof memberReferralSchema>

export const orderDetailSchema = z.object({
  appointments: z.array(orderDetailActiveAppointmentsSchema),
  cancellable: z.boolean(),
  cancellationCompletionDate: z.string().optional(),
  id: z.string(),
  key: z.string(),
  orderDate: z.string(),
  paid: z.boolean(),
  plan: broadbandPlanMemberSchema,
  premise: broadbandPremiseSchema,
  serviceReferral: ServiceReferralSchema,
  stage: z.string(),
  state: z.string(),
  stateDescription: z.string().optional(),
  replaceable: z.boolean().optional(),
  actualCompletionTime: z.string().optional(),
  memberReferral: memberReferralSchema,
})

export type OrderDetail = z.infer<typeof orderDetailSchema>
